export type CurrencyObject = {
  symbol: string;
  code: number;
  name: string;
};

export const UAH_CURRENCY: CurrencyObject = { symbol: '₴', code: 980, name: 'UAH' };
export const USD_CURRENCY: CurrencyObject = { symbol: '$', code: 840, name: 'USD' };
export const EUR_CURRENCY: CurrencyObject = { symbol: '€', code: 978, name: 'EUR' };
export const SUPPORTED_CURRENCIES = [USD_CURRENCY, EUR_CURRENCY, UAH_CURRENCY];

const EUROPE_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'HR',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];

const getCurrencyForCountry = (countryCode?: string): CurrencyObject => {
  switch (true) {
    case countryCode === 'UA':
      return UAH_CURRENCY;
    case countryCode === 'US':
      return USD_CURRENCY;
    case EUROPE_COUNTRIES.includes(countryCode || ''):
      return EUR_CURRENCY;
    default:
      return USD_CURRENCY;
  }
};

export default getCurrencyForCountry;
